import axiosInstance from "../../utilities/interceptorUtilities";
import {
  claimsFetchError,
  claimSummaryFetchError,
  genericError,
} from "../../constants/messages";
import { setLoading, setAlertModal } from "./app";
import { PERSONAL } from "../../constants/keys";

export const GET_PERSONAL_CLAIMS = "GET_PERSONAL_CLAIMS";
export const GET_COMMERCIAL_CLAIMS = "GET_COMMERCIAL_CLAIMS";
export const GET_AGENT_CLAIMS = "GET_AGENT_CLAIMS";
export const GET_CLAIM_SUMMARY = "GET_CLAIM_SUMMARY";
export const SET_ACTIVE_CLAIM = "SET_ACTIVE_CLAIM";
export const NAVIGATE_CLAIMS_REMARKS = "NAVIGATE_CLAIMS_REMARKS";

export const getClaims = (accountId, accountType) => {
  return async (dispatch, getState) => {
    try {
      dispatch(setLoading(true));

      const userInfo = getState().user.userInfo;
      const url = process.env.REACT_APP_API_URL + "/api/Claims/ViewAllClaims";
      const body = { accountId: accountId, userId: userInfo.UserId };

      const response = await axiosInstance.post(url, body, {
        headers: {
          "content-type": "application/json",
        },
        withCredentials: true,
      });

      const responseClaims = response.data.ClaimDetail;

      let claims = [];

      if (responseClaims) {
        responseClaims.forEach((claim) => {
          let claimantName = "";
          if (claim.ClaimantName) {
            claimantName = claim.ClaimantName;

            if (claim.SubClaimCount > 1) {
              claimantName += " (*)";
            }
          }

          claims.push({
            claimNumber: !claim.ClaimNumber ? "" : claim.ClaimNumber,
            lossDate: !claim.LostDate ? "" : claim.LostDate,
            claimantName,
            policyNumber: !claim.PolicyNumber ? "" : claim.PolicyNumber,
            lossType: !claim.LostType ? "" : claim.LostType,
            claimStatus: !claim.ClaimStatus ? "" : claim.ClaimStatus,
            evaluation: !claim.Evaluation ? "" : claim.Evaluation,
          });
        });
      }

      if (accountType === PERSONAL) {
        dispatch({ type: GET_PERSONAL_CLAIMS, claims });
      } else {
        dispatch({ type: GET_COMMERCIAL_CLAIMS, claims });
      }

      dispatch(setLoading(false));
    } catch (err) {
      dispatch(setLoading(false));
      dispatch(setAlertModal(true, "error", claimsFetchError));
      setTimeout(() => {
        dispatch(setAlertModal(false, ""));
      }, 5000);
    }
  };
};

export const getAgentClaims = (policyNumber) => {
  return async (dispatch, getState) => {
    try {
      dispatch(setLoading(true));

      const agentInfo = getState().user.agentInfo;
      const url = process.env.REACT_APP_API_URL + "/api/Claims/ViewAllClaims";
      const body = {
        PolicyNumber: policyNumber,
        AgentCode: agentInfo.agentCode,
        IsAgent: true,
      };

      const response = await axiosInstance.post(url, body, {
        headers: { "content-type": "application/json" },
        withCredentials: true,
      });

      const responseClaims = response.data.ClaimDetail;

      let claims = [];
      responseClaims.forEach((claim) =>
        claims.push({
          claimNumber: !claim.ClaimNumber ? "" : claim.ClaimNumber,
          lossDate: !claim.LostDate ? "" : claim.LostDate.split(" ")[0],
          claimantName: !claim.ClaimantName ? "" : claim.ClaimantName,
          policyNumber: !claim.PolicyNumber ? "" : claim.PolicyNumber,
          lossType: !claim.LostType ? "" : claim.LostType,
          claimStatus: !claim.ClaimStatus
            ? ""
            : claim.ClaimStatus === "S"
            ? "Submitted"
            : claim.ClaimStatus,
          evaluation: !claim.Evaluation ? "" : claim.Evaluation,
        })
      );

      dispatch(setLoading(false));
      dispatch({ type: GET_AGENT_CLAIMS, claims });
    } catch (err) {
      dispatch(setLoading(false));
      dispatch(setAlertModal(true, "error", claimsFetchError));
      setTimeout(() => {
        dispatch(setAlertModal(false, ""));
      }, 5000);
    }
  };
};

export const getClaimSummary = (claimId) => {
  return async (dispatch, getState) => {
    try {
      const userInfo = getState().user.userInfo;
      let url = process.env.REACT_APP_API_URL + "/api/Claims/TrackClaim";
      let body = { claimNumber: claimId, accountId: userInfo.AccountId };
      
      const summaryResponse = await axiosInstance.post(url, body, {
        headers: { "content-type": "application/json" },
        withCredentials: true,
      });

      if (summaryResponse.data.IsDataFound) {
        url = process.env.REACT_APP_API_URL + "/api/Claims/ClaimPaymentHistory";
        body = { claimNumber: claimId };

        const paymentHistoryResponse = await axiosInstance.post(url, body, {
          headers: { "content-type": "application/json" },
          withCredentials: true,
        });

        let claimSummary = null;

        claimSummary = {
          claimNumber: claimId,
          status: summaryResponse.data.Status,
          claimClosedDate: summaryResponse.data.ClaimClosedDate,
          insured: summaryResponse.data.Insured,
          lossDate: summaryResponse.data.LossDate,
          claimantName: summaryResponse.data.ClaimantName,
          policyNumber: summaryResponse.data.PolicyNumber,
          policyPeriod: `${summaryResponse.data.PolicyEffectiveDate} - ${summaryResponse.data.PolicyExpirationDate}`,
          accidentCityState: `${summaryResponse.data.AccidentCity}, ${summaryResponse.data.AccidentState}`,
          claimType: summaryResponse.data.ClaimType,
          claimDescription: summaryResponse.data.ClaimDescription,
          claimSpecialistName: summaryResponse.data.ClaimSpecialistName,
          claimSpecialistOfficeAddress:
            summaryResponse.data.ClaimSpecialistOfficeAddress,
          claimSpecialistTelephone:
            summaryResponse.data.ClaimSpecialistTelephone,
          claimSpecialistEmail: summaryResponse.data.ClaimSpecialistEmail,
          claimSpecialistFax: summaryResponse.data.ClaimSpecialistFax,
          totalAmount: paymentHistoryResponse.data.TotalAmount,
        };

        dispatch({ type: GET_CLAIM_SUMMARY, claimSummary });
      }
      dispatch(setLoading(false));
    } catch (err) {
      dispatch(setLoading(false));
      dispatch(setAlertModal(true, "error", claimSummaryFetchError));
      setTimeout(() => {
        dispatch(setAlertModal(false, ""));
      }, 5000);
    }
  };
};

export const setActiveClaim = (claimNumber) => {
  return async (dispatch) => {
    try {
      dispatch({ type: SET_ACTIVE_CLAIM, claimNumber });
    } catch (err) {
      dispatch(setAlertModal(true, "error", genericError));
      setTimeout(() => {
        dispatch(setAlertModal(false, ""));
      }, 5000);
    }
  };
};

export const navigateClaimsRemarks = (remarksUrl) => {
  return async (dispatch, getState) => {
    try {
      let evaluationUrl = remarksUrl.split("?");
      let evaluationId;

      if (evaluationUrl[0].includes("ClaimRemarksLP")) {
        evaluationId = 2;
      } else {
        evaluationId = 1;
      }

      const queryString = {
        QueryString: evaluationUrl[1],
        MethodName: "evaluation",
      };

      const url = process.env.REACT_APP_API_URL + "/api/Integration/InsertQS";
      const claimsRemarksResponse = await axiosInstance.post(url, queryString, {
        headers: { "content-type": "application/json" },
        withCredentials: true,
      });

      if (claimsRemarksResponse != null) {
        let evaluationGUID = claimsRemarksResponse.data;
        if (evaluationId === 1) {
          window.open(
            String(
              evaluationUrl[0] +
                "?" +
                "id=" +
                evaluationGUID +
                "&origin=CCC&env=" +
                process.env.REACT_APP_ENVIRONMENT
            ),
            "_blank"
          );
        } else if (evaluationId === 2) {
          window.open(
            String(evaluationUrl[0] + "?" + "Guid=" + evaluationGUID),
            "_blank"
          );
        }
      }
    } catch (err) {
      dispatch(setAlertModal(true, "error", genericError));
      setTimeout(() => {
        dispatch(setAlertModal(false, ""));
      }, 5000);
    }
  };
};
